export default {
  home: '/',
  auth: {
    signIn: '/sign-in',
  },
  base: '/',
  albums: '/albums',
  album: (uuid, stems) =>
    uuid ? `/albums/${uuid}${stems ? '/stems' : ''}` : '/albums/:uuid/:kind?',
  labels: '/labels',
  label: (uuid, kind = 'albums') => {
    return uuid ? `/labels/${uuid}/${kind}` : '/labels/:uuid/:kind';
  },
  tracks: '/tracks',
  tracksHistory: '/tracks/history',
};
